import React from 'react';

class Placeholder extends React.Component {
    constructor(props) {
        super(props);
        this.widths = this.getRandomWidths();
    }

    getRandomWidths() {
        let widths = [];
        for(let i = 1; i<=6; i++) {
            widths.push(Math.floor(Math.random() * 100) + 10)
        }

        return widths;
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card m-b-20">
                        <div className="card-block">
                            <div className="mb-3 placeholder placeholder__form-title placeholder--fade-in placeholder--margin-top"/>
                            <div className="form-group row">
                                <div className="col-sm-2 placeholder--margin-top">
                                    <div className="placeholder placeholder__form-label placeholder--fade-in "/>
                                </div>
                                <div className="col-sm-10 ">
                                    <div className="placeholder placeholder__form-input placeholder--fade-in"/>
                                    <div className="card card-default top-indent placeholder--fade-in">
                                        <div className="card-block">
                                            <blockquote className="card-blockquote">
                                                <div className="placeholder placeholder__blockquoute-text"/>
                                                <div className="placeholder placeholder__blockquoute-text"/>
                                                <div className="placeholder placeholder__blockquoute-text"/>
                                                <div className="placeholder placeholder__blockquoute-text"/>
                                                <div
                                                    className="placeholder placeholder__blockquoute-text placeholder__blockquoute-text--end-line"/>
                                                <div className="placeholder__blockquoute-button-container">
                                                    <button className="btn btn-primary">
                                                        <div
                                                            className="placeholder__blockquoute-text blockquote__button-text blockquoute__button-text--primary"/>
                                                    </button>
                                                </div>
                                            </blockquote>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-2">
                                    <div className=" placeholder placeholder__form-label  placeholder--fade-in"/>
                                </div>
                                <div className="col-sm-10 placeholder__checkbox-container placeholder--fade-in">
                                    <div className="placeholder placeholder__checkbox"/>
                                    <div className="placeholder placeholder__checkbox-description"/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-2">
                                    <div className="placeholder placeholder__form-label placeholder--fade-in"/>
                                </div>
                                <div className="col-sm-10 ">
                                    <div className="placeholder placeholder__form-input placeholder--fade-in"/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-2">
                                    <div className="placeholder placeholder__form-label placeholder--fade-in"/>
                                </div>
                                <div className="col-sm-10 ">
                                    <div className="placeholder placeholder__form-input placeholder--fade-in"/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-2">
                                    <div className="placeholder placeholder__form-label placeholder--fade-in"/>
                                </div>
                                <div className="col-sm-10 ">
                                    <div className="placeholder placeholder__form-input placeholder--fade-in"/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-2">
                                    <div className="placeholder placeholder__form-label placeholder--fade-in"/>
                                </div>
                                <div className="col-sm-10 ">
                                    <div className="placeholder placeholder__text-editor placeholder--fade-in">
                                        <div className="card-block">
                                            <div className="placeholder placeholder__blockquoute__text"/>
                                            <div className="placeholder placeholder__blockquoute-text"/>
                                            <div className="placeholder placeholder__blockquoute-text"/>
                                            <div className="placeholder placeholder__blockquoute-text"/>
                                            <div className="placeholder placeholder__blockquoute-text"/>
                                            <div className="placeholder placeholder__blockquoute-text"/>
                                            <div className="placeholder placeholder__blockquoute-text"/>
                                            {this.widths.map((width, i) =>
                                                <div key={i} className={`placeholder placeholder__blockquoute-text placeholder__blockquoute-text--width-${width}`}/>)
                                            }
                                            <div
                                                className="placeholder placeholder__blockquoute-text placeholder__blockquoute-text--width-30"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-12">
                                    <div className="offset-sm-2">
                                        <button className="btn btn-primary">
                                            <div
                                                className="placeholder__blockquoute-text blockquote__button-text blockquoute__button-text--primary"/>
                                        </button>
                                        <button className="btn btn-secondary ml-3">
                                            <div
                                                className="placeholder__blockquoute-text blockquote__button-text blockquote__button-text--secondary"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Placeholder;


// WEBPACK FOOTER //
// ./web/src/components/Placeholder.jsx